import { useCallback, useEffect, useState } from 'react';
import { useAppDispatch } from '@store';
import { useLazyGetCustomerStatsQuery } from '../../../customers/store/services/customers';
import { BaseStatistics, ProfitByCustomer } from '../types';
import { setType } from '../../store/slices/statistics';

const useStatistics = ({
  customerId,
  baseStatistic,
  profitByCustomer,
}: {
  customerId?: string;
  baseStatistic?: BaseStatistics[];
  profitByCustomer?: ProfitByCustomer;
}) => {
  const [baseStatisticDates, setBaseStatisticsDate] = useState<Date[]>([]);
  const [profitByCustomerDates, setProfitByCustomerDate] = useState<Date[]>([]);

  const dispatch = useAppDispatch();

  const [getBaseStatistics, { isLoading, isFetching, isSuccess }] =
    useLazyGetCustomerStatsQuery();
  const [
    getProfitByCustomer,
    { isLoading: profitIsLoading, isFetching: profitIsFetching },
  ] = useLazyGetCustomerStatsQuery();

  const getBaseStatisticsAction = useCallback((query?: string) => {
    getBaseStatistics({ id: customerId as string, query });
  }, []);

  const getProfitByCustomerAction = useCallback((query?: string) => {
    getProfitByCustomer({ id: customerId as string, query });
  }, []);

  useEffect(() => {
    if (!baseStatistic && !profitByCustomer && customerId) {
      getBaseStatisticsAction();
    }
  }, [baseStatistic, customerId, profitByCustomer]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(setType(undefined));
    }
  }, [isSuccess]);

  return {
    isLoading,
    isFetching,
    baseStatisticDates,
    setBaseStatisticsDate,
    getBaseStatisticsAction,
    profitIsLoading,
    profitIsFetching,
    profitByCustomerDates,
    setProfitByCustomerDate,
    getProfitByCustomerAction,
  };
};

export default useStatistics;
